import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { initPerformanceOptimizations } from "@/utils/performanceOptimizations";

// Initialize performance optimizations before React render
// FIXED: Removed preload of non-existent files, improved error handling
// Includes: critical CSS, DNS prefetch, lazy loading, SW registration, Core Web Vitals
initPerformanceOptimizations();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
